import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'utils/modifiedTranslation';
import useRecaptcha from 'utils/hooks/useRecaptcha';
import { addPatient } from 'modules/hcp/actions/addPatient';
import { RESPONSE_ERROR } from 'utils/constants/responseError';
import { UserSignupForm } from './components/UserSignupForm/UserSignupForm';

const { USER_EXISTS: USER_EXISTS_ERROR_CODE } = RESPONSE_ERROR;

export const AddHCPPatient = ({
  onSuccess,
  indication,
  isFirstPatient,
}) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const { recaptcha, getRecaptchaTokenAsync } = useRecaptcha();

  const { t } = useTranslation();

  // eslint-disable-next-line consistent-return
  const handleFormSubmit = async (formData) => {
    const {
      indication: formIndication,
      name,
      email,
    } = formData ?? {};
    const { value: indicationValue, type: indicationType } = formIndication ?? {};

    if (!indicationValue || !name) {
      // should be invariant
      setError('error');
      return;
    }

    setError(null);
    const recaptchaToken = await getRecaptchaTokenAsync();

    await dispatch(addPatient({
      email,
      name,
      indication: indicationValue,
      indicationType,
      onError: (ex) => {
        const { response: { data: { code } = {} } = {} } = ex ?? {};
        let errorMessage = t('add_patient.error.something_went_wrong');
        if (code === USER_EXISTS_ERROR_CODE) {
          errorMessage = t('add_patient.error.email_duplication');
        }
        setError(errorMessage);
      },
      recaptchaToken,
      onSuccess,
    }));
  };

  return (
    <UserSignupForm
      indication={indication}
      onSubmit={handleFormSubmit}
      recaptcha={recaptcha}
      error={error}
      title={isFirstPatient ? t('add_patient.add_first') : t('general.add_patient')}
      indicationTitle={t('add_patient.indication_input_title')}
      buttonTitle={t('add_patient.add')}
      nameTitle={t('add_patient.name_input_title')}
      emailTitle={t('add_patient.email_input_title')}
    />
  );
};

AddHCPPatient.propTypes = {
  indication: PropTypes.shape({
    value: PropTypes.string.isRequired,
    type: PropTypes.string,
  }),
  onSuccess: PropTypes.func.isRequired,
  isFirstPatient: PropTypes.bool.isRequired,
};
